import { render, staticRenderFns } from "./AppointmentsTabsAll.vue?vue&type=template&id=123d48da&scoped=true"
import script from "./AppointmentsTabsAll.vue?vue&type=script&lang=js"
export * from "./AppointmentsTabsAll.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsTabsAll.vue?vue&type=style&index=0&id=123d48da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d48da",
  null
  
)

export default component.exports